// extracted by mini-css-extract-plugin
var _1 = "ExchangeAmountStyle-module__exchange-amount___diGOg";
var _2 = "ExchangeAmountStyle-module__exchange-amount___diGOg";
var _3 = "ExchangeAmountStyle-module__trading-fee___yLmIG";
var _4 = "ExchangeAmountStyle-module__trading-fee-url___k8I6Q";
var _5 = "ExchangeAmountStyle-module__trading-fee-wrapper___fbM8q";
var _6 = "ExchangeAmountStyle-module__trading-fee___yLmIG";
var _7 = "ExchangeAmountStyle-module__trading-fee-url___k8I6Q";
var _8 = "ExchangeAmountStyle-module__trading-fee-wrapper___fbM8q";
var _9 = "ExchangeAmountStyle-module__transaction-fee___wODkQ";
var _a = "ExchangeAmountStyle-module__transaction-fee___wODkQ";
export { _1 as "exchange-amount", _2 as "exchangeAmount", _3 as "trading-fee", _4 as "trading-fee-url", _5 as "trading-fee-wrapper", _6 as "tradingFee", _7 as "tradingFeeUrl", _8 as "tradingFeeWrapper", _9 as "transaction-fee", _a as "transactionFee" }
